import { Component, Input } from '@angular/core';
import { BaseAreaAccordionComponent } from '../base-accordion.component';
import { AccordionService } from 'src/app/services/accordion.service';

@Component({
  selector: 'app-area-details-instructions',
  templateUrl: './area-details-instructions.component.html',
  styleUrls: ['./area-details-instructions.component.scss'],
})
export class AreaDetailsInstructionsComponent extends BaseAreaAccordionComponent {
  @Input() area;
  @Input() isEditingDisabled = false;

  constructor(accordionService: AccordionService) {
    super(accordionService);
  }
}
